<template>
  <div :class="$options.name">

    <OverlayLoader :visible="!ready" />

    <!-- Hero Quad -->
    <HeroQuad :services="services"
      @open-service="activeModal = $event.key || $event.id"
      @open-contact="openContact"
      @ready="imagesReady = true" />

    <ServiceModal :is-open="!!activeService"
      :service="activeService"
      contact-label="Küsi pakkumist"
      dark
      @contact="openContact"
      @close="activeModal = null" />

    <ContactModal :is-open="showContact"
      :service="contactService"
      dark
      @close="showContact = false" />
  </div>
</template>

<script>
import HeroQuad from '@/components/HeroQuad.vue'
import ServiceModal from '@/components/modal/service.vue'
import ContactModal from '@/components/modal/contact.vue'
import { ServiceModel } from '@/models/ServiceModel'

export default {
  name: 'home',
  components: {
    HeroQuad,
    ServiceModal,
    ContactModal
  },
  data() {
    return {
      activeModal: null,
      services: [],
      imagesReady: false,
      servicesReady: false,
      showContact: false,
      contactService: ''
    }
  },
  computed: {
    ready() {
      return this.imagesReady && this.servicesReady
    },
    activeService() {
      return this.activeModal != null
        ? this.services.find(s => (s.key || s.id) === this.activeModal)
        : null
    }
  },
  created() {
    this.fetchServices()
  },
  methods: {
    async fetchServices() {
      try {
        const result = await new ServiceModel().find({
          params: { include: 'pricing' },
          asPlainData: true,
          limit: 3,
        })
        const items = Array.isArray(result) ? result : result.data || []
        this.services = items.filter(s => s.isActive !== false).map(s => ({
          ...s,
          pricing: (s.pricing || []).filter(p => p.isActive !== false)
        }))
      } catch (e) {
        console.warn('Failed to load services from API', e)
      } finally {
        this.servicesReady = true
      }
    },
    openContact() {
      const service = this.activeService
      this.contactService = service?.id || ''
      this.showContact = true
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}
</style>
